import { render, staticRenderFns } from "./Alteka.vue?vue&type=template&id=033d0148&scoped=true&"
import script from "./Alteka.vue?vue&type=script&lang=js&"
export * from "./Alteka.vue?vue&type=script&lang=js&"
import style0 from "./Alteka.vue?vue&type=style&index=0&id=033d0148&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "033d0148",
  null
  
)

export default component.exports